import PerfectDay from '../Assets/projects/perfect-day.png';
import BookIt from '../Assets/projects/book-it.gif';
import NoteTaker from '../Assets/projects/note-taker.gif';
import PasswordGenerator from '../Assets/projects/password-generator.png';
import TextEditor from '../Assets/projects/text-editor.png';
import Portfolio from '../Assets/projects/portfolio.gif';
import GrapplingCamp from '../Assets/projects/grappling-camp.png';
import yardtotable from '../Assets/projects/yardtotable.gif';


export const work =[
    {
        id:1,
        name: "Yard to Table",
        image: yardtotable,
        description: "A market place for gardeners to connect to homeowners",
        github:"https://github.com/codemodeactivate/yard-to-table",
        live: "https://hidden-beyond-87879-91f0e9d6f69e.herokuapp.com/"

    },
    {
        id:2,
        name:"Perfect Day Planner",
        image: PerfectDay,
        description: 'Set up a perfect date for you and your mate!',
        github:"https://github.com/codemodeactivate/perfect-day-planner",
        live:"https://perfect-day.herokuapp.com/",
    },
    {
        id:3,
        name:"Book It",
        image: BookIt,
        description: 'Keep track of the books you want to read, have read, and are reading!',
        github:"https://github.com/codemodeactivate/book-it",
        live:"https://codemodeactivate.github.io/book-it/",
    },
    {
        id:4,
        name:"Note Taker",
        image: NoteTaker,
        description: 'Take Notes. CRUD application to learn Express.js',
        github:"https://github.com/codemodeactivate/note-taker-express",
        live:"https://note-taker-codemodeactivate.herokuapp.com/",
    },
    {
        id:5,
        name:"Password Generator",
        image: PasswordGenerator,
        description: 'Password Generator to learn JavaScript',
        github:"https://github.com/codemodeactivate/password-generator",
        live:"https://codemodeactivate.github.io/password-generator/",
    },
    {
        id:6,
        name:"Text Editor",
        image: TextEditor,
        description: 'CRUD Progressive Web Application',
        github:"https://github.com/codemodeactivate/text-editor",
        live:"https://jz-jate-b7abb8830677.herokuapp.com/",
    },
    {
        id:7,
        name:"Portfolio Site",
        image: Portfolio,
        description: 'You are here!',
        github:"https://github.com/codemodeactivate/react-portfolio",
        live:"https://jeffzenko.com/",
    },
    {
        id:8,
        name:"Grappling Camp",
        image: GrapplingCamp,
        description: 'Find Grappling Camps near you! Made with WordPress.',
        github:"/",
        live:"https://grappling.camp",
    },


]
